<template>
  <input type="text"
    v-model="this.value"
    class="form-control note-line"
    v-on:keydown.down="prevDefault"
    v-on:keydown.up="prevDefault"
    v-on:keyup.up="handleUp"
    v-on:keyup.down="handleDown" />
</template>

<script>
export default {
  name: 'NotesFormLine',
  props: {
    position: Number,
    value: String
  },
  methods: {
    handleUp(event) {
      if (event) event.preventDefault()
      if (this.position > 0) {
        this.$el.parentElement.previousElementSibling.firstElementChild.focus()
      }
    },
    handleDown(event) {
      if (event) event.preventDefault()

      this.$el.parentElement.nextElementSibling.firstElementChild.focus()
    },
    prevDefault(event) {
      if (event) event.preventDefault()
    }
  }
}
</script>

<style>
  .form-control.note-line:focus {
    background-color: rgb(229, 231, 250);
    border-color: transparent;
    box-shadow: 0 0 0 0 transparent;
  }
  .note-line {
    border-radius: 0%;
    border: 0px solid white;
  }
</style>


// WEBPACK FOOTER //
// src/components/NotesFormLine.vue